<template>
  <div
    id="engagement"
  >
    <div
      class="slotGroup"
    >
      <div class="verticalSlot first">
        <div class="stack top">
          {{ $t('oa.engagement.sessionNo') }}
        </div>
        <div class="stack">
          {{ $t('oa.engagement.leaderEngagement') }}
          <el-tooltip
            effect="dark"
            placement="top"
            :content="$t('oa.engagement.leaderTooltip')"
          >
            <i class="el-icon-info"></i>
          </el-tooltip>
        </div>
        <div class="stack">
          {{ $t('oa.engagement.coworkerEngagement') }}
          <el-tooltip
            effect="dark"
            placement="top"
            :content="$t('oa.engagement.coworkerTooltip')"
          >
            <i class="el-icon-info"></i>
          </el-tooltip>
        </div>
      </div>

      <div
        v-for="(item, index) in engagement.data_list"
        :key="`ii${index}`"
        class="verticalSlot second"
      >
        <div class="stack top">
          {{ item.session_id.split('_')[1] }}
        </div>
        <div class="stack">
          <span v-if="item.leader_er">
            {{ Math.round(item.leader_er * 100) }}%
          </span>
          <span v-else>
            -
          </span>
        </div>
        <div
          class="stack"
          :class="{
            pulseSession: ['6', '9'].includes(item.session_id.split('_')[1])
          }"
        >
          <span v-if="item.stakeholder_er">
            {{ Math.round(item.stakeholder_er * 100) }}%
          </span>
          <span v-else>
            -
          </span>
          <el-tooltip
            v-if="['6', '9'].includes(item.session_id.split('_')[1])"
            effect="dark"
            placement="top"
            :content="$t('oa.engagement.pulseTooltip', {
              number: item.session_id === 'session_6' ? 'I' : 'II',
            })"
          >
            <i class="el-icon-info"></i>
          </el-tooltip>
        </div>
      </div>

      <div class="verticalSlot third">
        <div class="stack top">
          {{ $t('oa.engagement.totalEngagement') }}
        </div>
        <div class="stack">
          <span
            v-if="engagement.leader_total_er"
          >
            {{ Math.round(engagement.leader_total_er * 100) }}%
          </span>
          <span v-else>
            -
          </span>
          <el-tooltip
            effect="dark"
            placement="top"
            :content="$t('oa.engagement.leaderAvgTooltip')"
          >
            <i class="el-icon-info"></i>
          </el-tooltip>
        </div>
        <div class="stack">
          <span
            v-if="engagement.stakeholder_total_er"
          >
            {{ Math.round(engagement.stakeholder_total_er * 100) }}%
          </span>
          <span v-else>
            -
          </span>
          <el-tooltip
            effect="dark"
            placement="top"
            :content="$t('oa.engagement.coworkerAvgTooltip')"
          >
            <i class="el-icon-info"></i>
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    engagement: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
  #engagement {
    width: 100%;
    scrollbar-color: #c8c8c8 transparent;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c8c8c8;
      border-radius: 20px;
    }

    &::-webkit-scrollbar-track {
      background: transparent !important;
    }

    .slotGroup {
      display: flex;
      width: 100%;
      min-width: 800px;
      padding: 0 0 5px 0;
      box-sizing: border-box;

      .verticalSlot {
        border-left: 1px solid var(--themeFontColor);
        border-right: 1px solid var(--themeFontColor);
        box-sizing: border-box;
        width: 100px;

        &.first {
          width: 200px;
        }

        &.third {
          width: 220px;
        }

        .stack {
          display: flex;
          justify-content: center;
          align-items: center;
          border-bottom: 1px solid var(--themeFontColor);
          border-top: 1px solid var(--themeFontColor);
          height: 100px;
          padding: 0 10px;

          &.top {
            height: 50px;
          }

          &.pulseSession {
            background-color: rgba(0, 223, 169, 0.2);
          }
        }
      }
    }

    .el-tooltip {
      padding: 3px;
      font-size: 0.9em;
    }
  }
</style>
